import { jsx } from "react/jsx-runtime";
import { Component } from "@contember/binding";
import { DataGridColumn } from "../base/DataGridColumn.js";
const GenericCell = Component((props) => {
  return /* @__PURE__ */ jsx(DataGridColumn, { ...props, enableOrdering: false, enableFiltering: false, children: props.children });
}, "GenericCell");
export {
  GenericCell
};
//# sourceMappingURL=GenericCell.js.map
